import * as i0 from "@angular/core";
export class ProjectDataService {
}
ProjectDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProjectDataService_Factory() { return new ProjectDataService(); }, token: ProjectDataService, providedIn: "root" });
